import 'tiny-slider/dist/tiny-slider.css';
import { tns, TinySliderInfo } from 'tiny-slider/src/tiny-slider';

function setupCarousel(carouselElement: HTMLElement) {
  const carouselContainerElement: HTMLElement = carouselElement.querySelector('.carousel-wrapper');
  const coverWrapperElement: HTMLElement = carouselElement.querySelector('.carousel-covers');

  if (coverWrapperElement) {
    [...coverWrapperElement.children].forEach((slideCover: HTMLElement, index) => {
      slideCover.dataset.eqCarouselItemIndex = `${index + 1}`;
    });
    updateCurrentCover(1, coverWrapperElement);
  }

  if (carouselContainerElement) {
    const itemsToDisplay =
      parseInt(carouselContainerElement.dataset?.['eqCarouselItemsToDisplay']) ?? 1;

    const prevButton: HTMLElement = carouselElement.querySelector('[aria-label=Previous]');
    const nextButton: HTMLElement = carouselElement.querySelector('[aria-label=Next]');

    const slider = tns({
      container: carouselContainerElement,
      slideBy: 'page',
      nav: false,
      mouseDrag: true,
      prevButton: prevButton,
      nextButton: nextButton,
      loop: false,
      responsive: {
        '640': {
          items: itemsToDisplay,
        },
      },
    });

    const carouselPaginationElement: HTMLElement =
      carouselElement.querySelector('.carousel-pagination');

    if (carouselPaginationElement) {
      const carouselCounterElement: HTMLElement = carouselElement.querySelector(
        '[data-eq-carousel-current-page]',
      );

      slider.events.on('transitionStart', function (info: TinySliderInfo) {
        const currentIndex = info.index + 1;
        updateCounter(currentIndex, carouselCounterElement);
        if (coverWrapperElement) {
          updateCurrentCover(currentIndex, coverWrapperElement);
        }
      });
    }
  }
}

function updateCounter(currentIndex: number, counterElement: HTMLElement): void {
  counterElement.setAttribute('data-eq-carousel-current-page', `${currentIndex}`);
}

function updateCurrentCover(currentIndex: number, coverWrapperElement: HTMLElement): void {
  [...coverWrapperElement.children].forEach((coverElement: HTMLElement) => {
    if (coverElement.dataset.eqCarouselItemIndex === `${currentIndex}`) {
      coverElement.setAttribute('aria-hidden', 'false');
    } else {
      coverElement.setAttribute('aria-hidden', 'true');
    }
  });
}

const Carousel = {
  init: () => {
    const carouselElements = document.querySelectorAll('[aria-label=carousel]');

    carouselElements?.forEach((carouselElement: HTMLElement) => {
      setupCarousel(carouselElement);
    });
  },
};

export default Carousel;
